import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconsService {
    /**
     * Constructor
     */
    constructor() {
        const domSanitizer = inject(DomSanitizer);
        const matIconRegistry = inject(MatIconRegistry);

        // Register icon sets
        matIconRegistry.addSvgIconSet(
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/material-twotone.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'mat_outline',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/material-outline.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'mat_solid',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/material-solid.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'feather',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/feather.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_outline',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/heroicons-outline.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_solid',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/heroicons-solid.svg'
            )
        );
        matIconRegistry.addSvgIconSetInNamespace(
            'heroicons_mini',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/heroicons-mini.svg'
            )
        );
        // Custom icons registry
        matIconRegistry.addSvgIcon(
            'security_icon',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/security.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'check_security_icon',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/check-security.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'credit_card',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/credit_card.svg'
            )
        );
        matIconRegistry.addSvgIcon(
            'pse',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/pse.svg')
        );
        matIconRegistry.addSvgIcon(
            'cash',
            domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/cash.svg')
        );
        matIconRegistry.addSvgIcon(
            'wallet',
            domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/icons/wallet.svg'
            )
        );
    }
}
